import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13 .5C6.1.5.5 6.1.5 13S6.1 25.5 13 25.5 25.5 19.9 25.5 13 19.9.5 13 .5Zm-2.5 18.75L4.25 13l1.763-1.762 4.487 4.475 9.488-9.488L21.75 8 10.5 19.25Z",
  fill: "#2E7D32"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };